import React from 'react'
import { IconEwiInfo } from 'components/Zui/Icon'
import { FormContainer, Input } from 'components/Form'
import { useIntl } from 'hooks'
import { validationSchema } from 'schema/inviteUser'
import config from 'app/config'
import Modal from 'components/Modals'
import { InlineMessage, DialogBox } from 'components/Zui'

const Invite = ({ onSubmit, onClose, userCount }) => {
    const { t } = useIntl()
    const maxUsers = config.SUBSCRIPTION.MAX_USER_INVITATIONS
    const usersLeft = maxUsers - userCount

    return (
        <Modal>
            <FormContainer
                initialValues={{
                    email: '',
                }}
                onSubmit={values => {
                    onSubmit(values)
                }}
                validationSchema={validationSchema(t)}
            >
                {formik => {
                    return (
                        <DialogBox
                            closable
                            headerText={t('invite.user')}
                            acceptLabel={t('invite')}
                            cancelLabel={t('cancel')}
                            onClose={onClose}
                            onCancel={onClose}
                            onAccept={formik.handleSubmit}
                            confirmPosition="right"
                        >
                            <div className="dialog-content-wrap">
                                <InlineMessage size="m">
                                    {t('invitations.left', {
                                        left: usersLeft,
                                        text: usersLeft < 2 ? t('user.small') : t('users.small'),
                                    })}
                                    <IconEwiInfo slot="icon" />
                                </InlineMessage>

                                <Input
                                    horizontal
                                    name="email"
                                    type="email"
                                    label={t('label.EMAIL.ADDR')}
                                />
                            </div>
                        </DialogBox>
                    )
                }}
            </FormContainer>
        </Modal>
    )
}

export default Invite
